// components/features/support/tasks/TasksList.tsx
import React from "react";
import { ClipboardList } from "lucide-react";
import { TaskItem } from "./TaskItem";
import { Task } from "../../../types/Task";

interface TasksListProps {
  tasks: Task[];
  loading?: boolean;
  emptyMessage?: string;
  onView?: (task: Task) => void;
  onEdit?: (task: Task) => void;
  onDelete?: (task: Task) => void;
}

export const TasksList: React.FC<TasksListProps> = ({
  tasks,
  loading = false,
  emptyMessage = "Aucune tâche pour le moment",
  onView,
  onEdit,
  onDelete,
}) => {
  if (loading) {
    return (
      <div className="space-y-3">
        {[...Array(3)].map((_, i) => (
          <div key={i} className="bg-white border border-gray-200 rounded-lg p-4 animate-pulse">
            <div className="h-4 bg-gray-200 rounded w-1/3 mb-2"></div>
            <div className="h-3 bg-gray-200 rounded w-2/3 mb-3"></div>
            <div className="h-3 bg-gray-200 rounded w-1/4"></div>
          </div>
        ))}
      </div>
    );
  }

  if (!tasks || tasks.length === 0) {
    return (
      <div className="bg-white border border-gray-200 rounded-lg p-12 flex flex-col items-center justify-center text-center">
        <ClipboardList className="w-12 h-12 text-gray-300 mb-3" />
        <p className="text-gray-500">{emptyMessage}</p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {tasks.map((task) => (
        <TaskItem key={task.id} task={task} onView={onView} onEdit={onEdit} onDelete={onDelete} />
      ))}
    </div>
  );
};
